module.exports = __webpack_public_path__ + "static/media/Trush.0e7c6ae3.svg";